import React, { useState } from 'react';
import '../shared.css';
import Sidebar from '../Components/Layout/sidebar';
import Topbar from '../Components/Layout/topbar';
import Button from '../Components/Comman/Button';

const FieldGroup = ({ label, children }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
    <label style={{ fontFamily: 'Inter', fontSize: 12, fontWeight: 600, color: '#191919' }}>{label}</label>
    {children}
  </div>
);

const Input = ({ defaultValue, type = 'text', placeholder }) => (
  <input
    type={type}
    defaultValue={defaultValue}
    placeholder={placeholder}
    style={{
      width: '100%', padding: '10px 14px', borderRadius: 6,
      border: '0.762px solid rgba(42,42,42,0.2)', background: '#F5F0E8',
      fontFamily: 'Inter', fontSize: 13, color: '#191919', outline: 'none',
      transition: 'border-color 0.18s',
    }}
    onFocus={e => e.currentTarget.style.borderColor = 'rgba(42,42,42,0.5)'}
    onBlur={e => e.currentTarget.style.borderColor = 'rgba(42,42,42,0.2)'}
  />
);

const Section = ({ title, children }) => (
  <div style={{
    background: 'rgba(214,184,147,0.45)', borderRadius: 10, padding: '24px 28px',
    display: 'flex', flexDirection: 'column', gap: 18,
  }}>
    <h4 style={{ fontFamily: '"Cormorant Garamond"', fontSize: 20, fontWeight: 600, color: '#191919', borderBottom: '1px solid rgba(42,42,42,0.1)', paddingBottom: 12 }}>{title}</h4>
    {children}
  </div>
);

const EventSettings = () => {
  const [bookingOpen, setBookingOpen] = useState(true);

  return (
    <main>
      <Sidebar />
      <div className='pagestrcutre'>
        <Topbar />

        <div className='pagetop_div'>
          <div className='pagetop_div1'>
            <h3 className='pagetop_text1'>Event Settings</h3>
            <Button text='Save Changes' icon={null} />
          </div>
          <p className='pagetop_text2'>Configure global settings for the exhibition</p>
        </div>

        <div className='page_content' style={{ paddingBottom: 40, display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* General info */}
          <Section title="General Information">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <FieldGroup label="Event Name">
                <Input defaultValue="Nebu Art Exhibition 2025" />
              </FieldGroup>
              <FieldGroup label="Organiser">
                <Input defaultValue="Nebu Events LLC" />
              </FieldGroup>
              <FieldGroup label="Start Date">
                <Input type="date" defaultValue="2025-06-01" />
              </FieldGroup>
              <FieldGroup label="End Date">
                <Input type="date" defaultValue="2025-06-15" />
              </FieldGroup>
              <FieldGroup label="Venue" >
                <Input defaultValue="Cairo International Convention Centre" />
              </FieldGroup>
              <FieldGroup label="City">
                <Input defaultValue="Cairo, Egypt" />
              </FieldGroup>
            </div>
          </Section>

          {/* Booking settings */}
          <Section title="Booking Settings">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <p style={{ fontFamily: 'Inter', fontSize: 13, fontWeight: 600, color: '#191919' }}>Bookings Open</p>
                <p style={{ fontFamily: 'Inter', fontSize: 12, color: '#8B8B7A' }}>Allow visitors to purchase tickets</p>
              </div>
              {/* Toggle */}
              <div
                onClick={() => setBookingOpen(!bookingOpen)}
                style={{
                  width: 46, height: 26, borderRadius: 99, cursor: 'pointer',
                  background: bookingOpen ? '#2d7a2d' : 'rgba(42,42,42,0.2)',
                  position: 'relative', transition: 'background 0.2s ease', flexShrink: 0,
                }}
              >
                <div style={{
                  position: 'absolute', top: 3, left: bookingOpen ? 23 : 3,
                  width: 20, height: 20, borderRadius: '50%', background: '#fff',
                  transition: 'left 0.2s ease', boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
                }} />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <FieldGroup label="Max Tickets per Order">
                <Input defaultValue="10" type="number" />
              </FieldGroup>
              <FieldGroup label="Booking Cutoff (hours before visit)">
                <Input defaultValue="24" type="number" />
              </FieldGroup>
              <FieldGroup label="Refund Policy">
                <select defaultValue="7days" style={{
                  width: '100%', padding: '10px 14px', borderRadius: 6,
                  border: '0.762px solid rgba(42,42,42,0.2)', background: '#F5F0E8',
                  fontFamily: 'Inter', fontSize: 13, color: '#191919', outline: 'none',
                }}>
                  <option value="none">No refunds</option>
                  <option value="7days">Within 7 days</option>
                  <option value="14days">Within 14 days</option>
                  <option value="anytime">Any time before visit</option>
                </select>
              </FieldGroup>
              <FieldGroup label="Currency">
                <select defaultValue="EGP" style={{
                  width: '100%', padding: '10px 14px', borderRadius: 6,
                  border: '0.762px solid rgba(42,42,42,0.2)', background: '#F5F0E8',
                  fontFamily: 'Inter', fontSize: 13, color: '#191919', outline: 'none',
                }}>
                  <option value="EGP">EGP — Egyptian Pound</option>
                  <option value="USD">USD — US Dollar</option>
                  <option value="EUR">EUR — Euro</option>
                </select>
              </FieldGroup>
            </div>
          </Section>

          {/* Notifications */}
          <Section title="Email Notifications">
            {[
              { label: 'Booking Confirmation Email',  sub: 'Send to visitor on successful booking' },
              { label: 'Payment Receipt',              sub: 'Send payment receipt on completion'    },
              { label: 'Reminder (24h before visit)',  sub: 'Send visit reminder to visitor'        },
              { label: 'Admin New Booking Alert',      sub: 'Notify admin on each new booking'     },
            ].map(({ label, sub }) => (
              <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid rgba(42,42,42,0.08)' }}>
                <div>
                  <p style={{ fontFamily: 'Inter', fontSize: 13, fontWeight: 500, color: '#191919' }}>{label}</p>
                  <p style={{ fontFamily: 'Inter', fontSize: 11.5, color: '#8B8B7A' }}>{sub}</p>
                </div>
                <input type="checkbox" defaultChecked style={{ width: 16, height: 16, cursor: 'pointer', accentColor: '#0D0D0D' }} />
              </div>
            ))}
          </Section>

          <button style={{
            alignSelf: 'flex-start',
            background: '#0D0D0D', color: '#D6B893', border: 'none',
            borderRadius: 6, padding: '11px 28px', fontFamily: 'Inter',
            fontSize: 13, fontWeight: 500, cursor: 'pointer',
            transition: 'background 0.2s ease, transform 0.15s ease',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#0D0D0D'; e.currentTarget.style.transform = 'none'; }}
          >Save All Settings</button>
        </div>
      </div>
    </main>
  );
};

export default EventSettings;